<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">Edit Card #{{card_id}}</p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <p class="control is-expanded">
          <label class="label">Bank</label>
          <input :class="{'input': true, 'is-danger': (cardErrors.cardBank !== '')}" v-model="cardBank">
          <span class="help is-danger">{{ cardErrors.cardBank }}</span>
        </p>
        <p class="control is-expanded">
          <label class="label">Holder</label>
          <input :class="{'input': true, 'is-danger': (cardErrors.cardHolder !== '')}" v-model="cardHolder">
          <span class="help is-danger">{{ cardErrors.cardHolder }}</span>
        </p>
        <p class="control is-expanded">
          <label class="label">Due Date</label>
          <input :class="{'input': true, 'is-danger': (cardErrors.cardExpiry !== '')}" v-model="cardExpiry">
          <span class="help is-danger">{{ cardErrors.cardExpiry }}</span>
        </p>
        <p class="control is-expanded">
          <label class="label">Nationality</label>
          <select class="select is-fullwidth" v-model="cardNationality" name="cardNationality" id="cardNationality" >
            <option value="1">National</option>
            <option value="0">International</option>
            <option value="2">Multi</option>
          </select>
          <span class="help is-danger">{{ cardErrors.cardNationality }}</span>
        </p>
        <p class="control is-expanded">
          <label class="label">Extend</label>
          <input :class="{'input': true, 'is-danger': (cardErrors.cardExtend !== '')}" v-model="cardExtend" placeholder="Inform Main CC ID">
          <span class="help is-danger">{{ cardErrors.cardExtend }}</span>
        </p>
        <p class="control is-expanded">
          <label class="label">Card Validity</label>
          <input :class="{'input': true, 'is-danger': (cardErrors.cardValidity !== '')}" v-model="cardValidity">
          <span class="help is-danger">{{ cardErrors.cardValidity }}</span>
        </p>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a :class="{'button': true, 'is-primary': true }" @click="close(true)">Close</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-loading': inProgress}" @click="save">Save</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import message from '../../utils/message'
  export default {
    props: {
      context: {
        type: Object
      },
      callback: {
        type: String
      },
      card_id: {
        type: Number
      }
    },
    data () {
      return {
        cardHolder: '',
        cardBank: '',
        cardExpiry: '',
        cardNationality: '',
        cardExtend: '',
        cardValidity: '',
        cardErrors: {
          cardHolder: '',
          cardBank: '',
          cardExpiry: '',
          cardNationality: '',
          cardExtend: ''
        },
        cardError: false,
        inProgress: false,
        error: ''
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.loadData()
      })
    },
    methods: {
      loadData () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/finances/cards/' + this.card_id).then((response) => {
          this.cardHolder = response.body.holder
          this.cardBank = response.body.bank
          this.cardExpiry = response.body.expiry
          this.cardNationality = response.body.nationality
          this.cardExtend = response.body.vc_card_id
          this.cardValidity = response.body.card_validity
          document.body.appendChild(this.$el)
        }, (response) => {
        })
      },
      close (result) {
        this.context[this.callback](result)
        this.$el.remove()
      },
      save () {
        this.cardErrors.cardExpiry = ''
        this.cardErrors.cardBank = ''
        this.cardErrors.cardHolder = ''
        this.cardErrors.cardNationality = ''
        this.cardErrors.cardExtend = ''
        this.cardErrors.cardValidity = ''
        this.cardError = false
        if (this.cardBank.trim() === '') {
          this.cardErrors.cardBank = 'Invalid Bank.'
          this.cardError = true
        } else {
          this.cardErrors.cardBank = ''
        }
        if (this.cardHolder.trim() === '') {
          this.cardErrors.cardHolder = 'Invalid Credit Card Holder.'
          this.cardError = true
        } else {
          this.cardErrors.cardHolder = ''
        }
        if ((this.cardValidity.trim()) === '' && (this.cardValidity.test('/[0-9]+/[0-9]+/i'))) {
          this.cardErrors.cardValidity = 'Invalid Credit Validity.'
          this.cardError = true
        } else {
          this.cardErrors.cardValidity = ''
        }
        if (!this.cardError) {
          this.context.$http.post(this.context.$store.state.config.apiURL + '/finances/cards/' + this.card_id, {cardHolder: this.cardHolder, cardBank: this.cardBank, cardExpiry: this.cardExpiry, cardNationality: this.cardNationality, cardExtend: this.cardExtend, cardValidity: this.cardValidity}).then((response) => {
            this.close(true)
            this.message('success', 'Success', 'The card was successfully edited')
          }, (response) => {
            this.message('danger', 'Error', response.body)
          })
        }
      },
      message (type, title, content) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
      }
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    }
  }
</script>
<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }

  .panel {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(167, 28, 32), 0px 0px 0px 1px rgb(167, 28, 32);
    color: #4a4a4a;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
    background-color: rgb(167, 28, 32);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// CardEdit.vue?9c4e5b5c